export default __webpack_public_path__ + "static/media/driver.06b2ca51.svg";